function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getCookie, setCookie } from 'typescript-cookie';
import { v1 as uuid } from 'uuid';
import { getDomain } from '../utils';
export const SESSION_START = '_session.start';
const SESSION_STORAGE_KEY = '@pushpay/analytics/session';
const twentyFourHours = 24 * 60 * 60 * 1000;
const halfAnHour = 30 * 60 * 1000;
const withinMaxSessionTime = ({
  StartTimestamp
}) => Date.now() - twentyFourHours < new Date(StartTimestamp).getTime();
export class SessionTracker {
  constructor() {
    _defineProperty(this, "record", void 0);
    _defineProperty(this, "currentSession", void 0);
    _defineProperty(this, "currentSessionExpiry", void 0);
    _defineProperty(this, "updateSession", session => {
      this.setSession(session);
    });
    _defineProperty(this, "startSession", () => {
      const session = {
        Id: uuid(),
        StartTimestamp: new Date().toISOString()
      };
      this.setSession(session);
      if (this.record) {
        this.record({
          name: SESSION_START
        });
      }
      return session;
    });
    _defineProperty(this, "trackSession", record => {
      this.record = record;
    });
    _defineProperty(this, "getOrStartSession", () => {
      const storedSession = getCookie(SESSION_STORAGE_KEY);
      if (storedSession) {
        const session = JSON.parse(storedSession);
        if (withinMaxSessionTime(session)) {
          this.updateSession(session);
          return session;
        }
      }
      if (this.currentSession && this.currentSessionExpiry && Date.now() < this.currentSessionExpiry.getTime() && withinMaxSessionTime(this.currentSession)) {
        this.updateSession(this.currentSession);
        return this.currentSession;
      }
      return this.startSession();
    });
  }
  setSession(session) {
    const inHalfAnHour = new Date(Date.now() + halfAnHour);
    setCookie(SESSION_STORAGE_KEY, JSON.stringify(session), {
      domain: getDomain(),
      expires: inHalfAnHour,
      secure: true
    });
    this.currentSession = session;
    this.currentSessionExpiry = inHalfAnHour;
  }
}